import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MapWaldCoreModule } from 'map-wald';

import { LeafletMapComponent } from './leaflet-map.component';
import { DrawComponent } from './draw.component';
import { GeojsonLayerComponent } from './geojson-layer.component';
import { LegendComponent } from './legend.component';
import { MapControlComponent } from './map-control.component';
import { OneTimeSplashComponent } from './one-time-splash.component';
import { VectorTileLayerComponent } from './vector-tile-layer.component';
import { WmsLayerComponent } from './wms-layer.component';
import { DateElementComponent } from './date-element.component';
import { DateSelectionComponent } from './date-selection.component';
import { MapCoordinatesComponent } from './map-coordinates.component';
import { SpatialDownloadPanelComponent } from './spatial-download-panel.component';
import { CircleMarkerComponent } from './circle-marker.component';
import { DropPinComponent } from './drop-pin.component';
import { TourComponent } from './tour.component';
import { TourService } from './tour.service';
import { TourSelectionComponent } from './tour-selection.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { BookmarkExtentComponent } from './bookmark-extent/bookmark-extent.component';
import { SelectExtentComponent } from './select-extent/select-extent.component';
import { DrawRectangleComponent } from './draw-rectangle.component';
import { TileLayerComponent } from './tile-layer.component';

export * from './data';
export * from './leaflet.service';
export * from './leaflet-map.component';
export * from './draw.component';
export * from './draw-rectangle.component';
export * from './geojson-layer.component';
export * from './legend.component';
export * from './map-control.component';
export * from './one-time-splash.component';
export * from './vector-tile-layer.component';
export * from './wms-layer.component';
export * from './tile-layer.component';
export * from './date-element.component';
export * from './date-time-picker/date-time-picker.component';
export * from './date-selection.component';
export * from './map-coordinates.component';
export * from './spatial-download-panel.component';
export * from './circle-marker.component';
export * from './drop-pin.component';
export * from './tour.component';
export * from './tour.service';
export * from './tour-selection.component';
export * from './bookmark-extent/bookmark-extent.component';
export * from './select-extent/select-extent.component';
export * from './utils';
export * from './base-main-map.component';

const components: any[] = [
  //$componentList
  DrawComponent,
  DrawRectangleComponent,
  GeojsonLayerComponent,
  LeafletMapComponent,
  LegendComponent,
  MapControlComponent,
  OneTimeSplashComponent,
  VectorTileLayerComponent,
  WmsLayerComponent,
  TileLayerComponent,
  DateElementComponent,
  DateSelectionComponent,
  DateTimePickerComponent,
  MapCoordinatesComponent,
  SpatialDownloadPanelComponent,
  CircleMarkerComponent,
  DropPinComponent,
  TourComponent,
  TourSelectionComponent,
  BookmarkExtentComponent,
  SelectExtentComponent
];

const services: any[] = [
  //$serviceList
  TourService
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    MapWaldCoreModule
  ],
  declarations: components,
  exports: components,
  providers: services
})
export class MapWaldLeafletModule {
  static forRoot(moduleInitialisation:any): ModuleWithProviders<MapWaldLeafletModule> {
    return {
      ngModule: MapWaldLeafletModule,
      providers: services
    };
  }
}
